
export const slugs: any = {
    personalAccount: {
        '*': '',
    },
    personalAccountProfile: {
        '*': 'profile',
        fr: 'profil',
    },
    personalAccountAddress: {
        '*': 'address',
        fr: 'adresse',
    },
    personalAccountManualAddress: {
        '*': 'manual-address',
        fr: 'adresse-manuelle',
    },
    personalAccountChangeID: {
        '*': 'change-id',
        fr: 'modifier-identite',
    },
    personalAccountChangeProofOfAddress: {
        '*': 'change-proof-of-address',
        fr: 'modifier-justificatif-domicile',
    },
    personalAccountChangeLicense: {
        '*': 'change-license',
        fr: 'modifier-permis',
    },
    personalAccountChangeInsuranceStatement: {
        '*': 'change-insurance-statement',
        fr: 'modifier-attestation-assurance',
    },
    personalAccountInvoices: {
        '*': 'invoices',
        fr: 'factures',
    },
    personalAccountCoupons: {
        '*': 'coupons',
        fr: 'coupons',
    },
    personalAccountAddCoupon: {
        '*': 'add-coupon',
        fr: 'ajouter-coupon',
    },
    personalAccountNotFound: {
        '*': '404'
    },
    personalAccountSettings: {
        '*': 'settings',
        fr: 'parametres',
    },
    personalAccountDownloadData: {
        '*': 'download-my-data',
        fr: 'telecharger-mes-donnees',
    },
    personalAccountNewsletter: {
        '*': 'newsletter',
        fr: 'newsletter',
    },
    personalAccountBookings: {
        '*': 'bookings',
        fr: 'reservations',
    },
    personalAccountBookingsCarsharingDetail: {
        '*': 'carsharing/:id',
        fr: 'carsharing/:id',
    },
    personalAccountBookingsRentDetail: {
        '*': 'rent/:id',
        fr: 'rent/:id',
    },
    personalAccountBookingsParkDetail: {
        '*': 'park/:id',
        fr: 'park/:id',
    }
};
